import React, { useEffect, useState } from "react";
import { getData, getDataIx0, putData } from "../../../../services/library";
import { Dialog, DialogContent, FormControl, Select, InputAdornment, MenuItem, InputLabel, Box, Grid, Typography, TextField, DialogActions, Button, Divider} from "@mui/material";
import { logEventos } from "../../../../services/services";
import Notify from "../../../Notify";
import { SignalCellularNoSimOutlined } from "@material-ui/icons";

export default function ModalEditar2(props) {
    const [datosf, setdatosf] = useState(props.datos);
    const [sucursales, setSucursales] = useState([]);
    const [datosTanque, setDatosTanque] = useState([]);
    const [disBtnGuardar, setDisBtnGuardar] = useState(false);
    const [kgCarga, setkgCarga] = useState(datosf.cantidad);
    const [ltsCarga, setltsCarga] = useState(datosf.ltsacargar);
    const [tanqueSel, setTanqueSel] = useState([]);
    const [capMaxKg, setCapMaxKg] = useState(null)

    // console.log(datosf)
    // console.log("datos tanque: ", datosTanque)
    
    let id_pedido = datosf.idpedido || datosf.id;

    let densidad = datosf.id_empresa === 4
        ? datosf.densidad_autogas
        : datosf.densidad_hipergas;

    useEffect(() => {
        getData("/sucursales/tipoPlanta", setSucursales);
        getDataIx0(`/tanques/${datosf.id_tanque}`, setDatosTanque)
    }, []);

    useEffect(() => {
        datosTanque.id_bateria &&
            getData(`/tanques/bateria/${datosTanque.id_bateria}`, setTanqueSel);
    }, [datosTanque]);

    // console.log("tanque seleccionado: ", tanqueSel)

    useEffect(() => {   
    // Definimos qué lista de tanques usar
    const tanquesAProcesar = (tanqueSel && tanqueSel.length > 0) 
        ? tanqueSel 
        : [datosTanque];

    // console.log("tanques a procesar: ", tanquesAProcesar)

    const sumaCapacidades = tanquesAProcesar.reduce((acc, t) => {
        // t.capacidad suele venir en m3, pasamos a Litros (* 1000)
        return acc + (parseFloat(t?.capacidad || 0) * 1000);
    }, 0);

    // console.log("suma capacidades: ", sumaCapacidades)

    // Capacidad Máxima al 85% convertida a Kg
    const maximoCalculado = sumaCapacidades * 0.85 * densidad;
    setCapMaxKg(maximoCalculado);
    
    }, [tanqueSel, datosTanque, densidad]);
    
    useEffect(() => {
        // Si al abrir el modal el pedido ya trae un porcentaje...
        if (datosf.porcentaje !== null && datosf.porcentaje !== undefined && datosf.porcentaje !== "") {
            // ...vaciamos la cantidad manual para que el useEffect de cálculo 
            // use el % y nos dé el kgCarga real basado en el tanque actual.
            setdatosf(prev => ({ ...prev, cantidad: null }));
        }
    }, []); // Se ejecuta una sola vez al montar el componente
        //una vez que tengo la capacidad maxima, defino los kg a cargar

    const definirKgACargar = () => {
        const cantManual = parseFloat(datosf.cantidad);
        const porcManual = parseFloat(datosf.porcentaje);

        // ESCENARIO A: El usuario escribe Kilos directamente
        if (cantManual > 0) {
            setkgCarga(cantManual.toFixed(0));
            setltsCarga((cantManual / densidad).toFixed(0));
            return;
        }

        // ESCENARIO B: El usuario escribe Porcentaje Actual
        if (porcManual >= 0 && capMaxKg > 0) {
            // Necesitamos la capacidad total nominal (al 100%) en kg para saber cuánto hay hoy
            const capTotalNominalKg = (capMaxKg / 0.85); 
            const contenidoActualKg = capTotalNominalKg * (porcManual / 100);
            
            // Lo que falta para llegar al 85%
            const disponibleKg = capMaxKg - contenidoActualKg;
            const resultadoKg = disponibleKg > 0 ? disponibleKg : 0;

            setkgCarga(resultadoKg.toFixed(0));
            setltsCarga((resultadoKg / densidad).toFixed(0));
            return;
        }

        // Si no hay nada, reset
        setkgCarga(0);
        setltsCarga(0);
    };

    useEffect(() => {
        // Solo ejecutamos el cálculo si tenemos la capacidad máxima ya definida
        // y si hay algún dato ingresado (cantidad o porcentaje)
        if (capMaxKg > 0) {
            definirKgACargar();
        } else if (!datosf.cantidad && !datosf.porcentaje) {
            // Si borran los inputs, limpiamos los resultados
            setkgCarga(0);
            setltsCarga(0);
        }
        
        // DEPENDENCIAS CRÍTICAS:
        // Escuchamos los inputs (cantidad, porcentaje), 
        // la capacidad calculada (capMaxKg) y la densidad.
    }, [datosf.cantidad, datosf.porcentaje, capMaxKg, densidad]);

    // console.log("cap maxima", capMaxKg);
    // console.log("tanquesel", tanqueSel);
    // console.log("datosTanque", datosTanque);
    // console.log("capMax", capMaxKg);
    // console.log("datosTanque", datosTanque);
    // console.log("datosf", datosf);
    // console.log("tanqueSel", tanqueSel && tanqueSel.length <=0);


    const almacenar = (e) => {
        setdatosf({
            ...datosf, [e.target.name]: e.target.value === "" ? null : e.target.value
        })
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const saveModificaciones = (e) => {
        // console.log(
        //     "kgacargar", kgCarga,
        //     "cantidad:", datosf.cantidad,
        //     "porcentaje:", datosf.porcentaje,
        //     "orden_prioridad:", datosf.orden_prioridad,
        //     "ltsacargar:", ltsCarga,
        //     "idsucursal_atiende:", datosf.idsucursal_atiende,
        //     "usuario_aumentakg:",
        //     (props.datos.id_estado === 21 || props.datos.id_estado === 23) &&
        //         props.datos.kgacargar * 1 < kgCarga
        //         ? localStorage.getItem("user")
        //         : props.datos.usuario_aumentakg)
        setDisBtnGuardar(true);
        putData(e,
            `/pedidos/${id_pedido}`,
            {
                kgacargar: kgCarga,
                cantidad: datosf.cantidad,
                porcentaje: datosf.porcentaje,
                orden_prioridad: datosf.orden_prioridad,
                ltsacargar: ltsCarga,
                idsucursal_atiende: datosf.idsucursal_atiende,
                usuario_aumentakg: localStorage.getItem('user'),
                usuario_aumentakg:
                    (props.datos.id_estado === 21 || props.datos.id_estado === 23) &&
                        props.datos.kgacargar * 1 < kgCarga
                        ? localStorage.getItem("user")
                        : props.datos.usuario_aumentakg,
            },
            setNotificacion,

        )
            .then(() => {
                logEventos('Modificacion', 'Crear Repartos', 'Modificar datos del pedido en el armado de repartos', localStorage.getItem('user'));

                if (props.vengo === 1) {
                    props.getPedidos()
                    props.tabla(true);
                    props.refreshRepartos();
                    props.setOpen(false);
                }
            })
            .catch(err => console.error("Error al guardar", err));
    };

    return (
        <Dialog open={props.open} onClose={() => props.setOpen(false)} fullWidth maxWidth="sm">
            <Grid
                xs={12}
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                backgroundColor="#1F618D" p={1.5}
            >
                <Typography variant="h5" color="#ffffff">
                    Editar pedido nro° {id_pedido}
                </Typography>
            </Grid>
        <DialogContent sx={{ p: 2, backgroundColor: "#fff" }}>
    
        <Box sx={{ mb: 2, p: 1, bgcolor: "#f8fafc", borderRadius: 1, border: "1px solid #e2e8f0", display: 'flex', justifyContent: 'space-around' }}>
        <Box>
        <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 700 }}>MÁX. PERMITIDO (85%)</Typography>
        <Typography sx={{ fontSize: "0.9rem", fontWeight: 800, color: "#1e293b" }}>{Number(capMaxKg).toFixed(0)} kg</Typography>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box>
        <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 700 }}>CAP. TOTAL (100%)</Typography>
        <Typography sx={{ fontSize: "0.9rem", fontWeight: 800, color: "#64748b" }}>{((capMaxKg / 0.85) / densidad).toFixed(0)} Lts</Typography>
        </Box>
        </Box>

        <Grid container spacing={2}>
        <Grid item xs={3}>
        <TextField
          fullWidth size="small" label="Prioridad" name="orden_prioridad"
          value={datosf.orden_prioridad || ""} onChange={almacenar}
        />
        </Grid>
        <Grid item xs={9}>
        <FormControl fullWidth size="small">
          <InputLabel>Sucursal abastece</InputLabel>
          <Select
            name="idsucursal_atiende"
            value={datosf.idsucursal_atiende || ""}
            label="Sucursal abastece"
            onChange={almacenar}
          >
            {sucursales?.map((s) => (
              <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>
            ))}
          </Select>
        </FormControl>
        </Grid>

        <Grid item xs={6}>
        <TextField
          fullWidth label="Cantidad" name="cantidad" type="number"
          value={datosf.cantidad || ""} onChange={almacenar}
          disabled={Boolean(datosf.porcentaje)}
          error={Number(datosf.cantidad) > Number(capMaxKg)}
          helperText={Number(datosf.cantidad) > Number(capMaxKg) ? "Excede el límite" : ""}
          InputProps={{ startAdornment: <InputAdornment position="start">kg</InputAdornment> }}
        />
        </Grid>

        <Grid item xs={6}>
        <TextField
          fullWidth label="Porcentaje" name="porcentaje" type="number"
          value={datosf.porcentaje || ""} onChange={almacenar}
          disabled={Boolean(datosf.cantidad)}
          error={Number(datosf.porcentaje) > 85}
          helperText={Number(datosf.porcentaje) > 85 ? "Límite 85% superado" : ""}
          InputProps={{ startAdornment: <InputAdornment position="start">%</InputAdornment> }}
        />
        </Grid>

        <Grid item xs={12}>
        <Box 
          sx={{ 
            display: 'flex', 
            bgcolor: '#eff6ff', 
            borderRadius: 1, 
            border: '1px solid #bfdbfe',
            overflow: 'hidden'
          }}
        >
        <Box sx={{ flex: 1, p: 1.5, textAlign: 'center', borderRight: '1px solid #bfdbfe' }}>
            <Typography variant="caption" sx={{ fontWeight: 800, color: '#1e40af', textTransform: 'uppercase' }}>
              Kg a cargar
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 900, color: '#1e3a8a' }}>
              {kgCarga || 0} <span style={{ fontSize: '0.8rem' }}>kg</span>
            </Typography>
        </Box>

        <Box sx={{ flex: 1, p: 1.5, textAlign: 'center' }}>
            <Typography variant="caption" sx={{ fontWeight: 800, color: '#1e40af', textTransform: 'uppercase' }}>
              Lts a cargar
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 900, color: '#1e3a8a' }}>
              {ltsCarga || 0} <span style={{ fontSize: '0.8rem' }}>Lts</span>
            </Typography>
        </Box>
        </Box>
        </Grid>
        </Grid>

                <DialogActions >
                    <Grid
                        mt={3}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Button 
                        onClick={() => props.setOpen(false)} 
                        color="error" 
                        // sx={{ fontWeight: 700 }}
                        variant="outlined">
                            VOLVER
                        </Button>
                        <Button
                            onClick={saveModificaciones}
                            variant="contained"
                            color="success"
                            disabled={Number(kgCarga) <= 0 || Number(datosf.cantidad) > Number(capMaxKg) || disBtnGuardar}
                            // sx={{ px: 4, fontWeight: 700, boxShadow: 'none' }}
                        >
                            GUARDAR CAMBIOS
                        </Button>
                    </Grid>
                </DialogActions>

        </DialogContent>
        {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={() => {
                        props.getPedidos();
                        props.setOpen(false)
                        // props.tabla(true);
                        props.refreshRepartos();
                        
                    }}
                    severity={notificacion.severity}
                />
            ) : null}
        </Dialog>
    )

}    // const definirKgACargar = () => {
    //     //si cargo el pedido a un tanque solo 
    //     if (tanqueSel && tanqueSel.length <= 0) {
    //         if (datosf.cantidad) {
    //             setkgCarga(datosf.cantidad);
    //             setltsCarga((datosf.cantidad / densidad).toFixed(0));
    //             datosf.porcentaje = null;
    //         }
    //         if (datosf.porcentaje) {
    //             const porcentaje = parseFloat(datosf.porcentaje) / 100;
    //             const capacidadUtil = tanqueSel && tanqueSel.capacidad * 1000 * 0.85;
    //             const capacidadConPorcentaje = capacidadUtil - (capacidadUtil * porcentaje);
    //             const capacidadKg = (capacidadConPorcentaje * densidad).toFixed(0);
    //             const capacidadLts = (capacidadConPorcentaje).toFixed(0);

    //             setkgCarga(capacidadKg);
    //             setltsCarga(capacidadLts)
    //         }
    //     } else {
    //         console.log("entro al else");
            
    //         if (datosf.cantidad) {
    //             setkgCarga(datosf.cantidad);
    //         };
    //         if (datosf.porcentaje) {
    //             //Map ->recorro cada tanque de la bateria y hago el calculo de los que le falta para llegar al 85% de acuerdo al % que tenga cargado.
    //             //Reduce -> suma cada valor del array nuevo que se forma con los kg que faltan para llenar los tanques de la bateria
    //             tanqueSel &&
    //                 setkgCarga(
    //                     tanqueSel
    //                         .map(
    //                             (item) =>
    //                                 (item.capacidad * 1 * 1000 * 0.85) -
    //                                 item.capacidad *
    //                                 1 *
    //                                 1000 *
    //                                 ((datosf.porcentaje * 1) / 100) *
    //                                 densidad
    //                         )
    //                         .reduce((acumulador, valorActual) => acumulador + valorActual, 0)
    //                         .toFixed(0)
    //                 );
    //             setltsCarga(tanqueSel
    //                     .map(
    //                         (item) =>
    //                             ((item.capacidad * 1 * 1000 * 0.85) -
    //                                 (item.capacidad *
    //                                 1 *
    //                                 1000 *
    //                                 ((datosf.porcentaje * 1) / 100) /
    //                             densidad))
    //                     )
    //                     .reduce((acumulador, valorActual) => acumulador + valorActual, 0)
    //                     .toFixed(0))
    //         };
    //     };
    //     if (datosf.porcentaje === null && datosf.cantidad === null) {
    //         setkgCarga(null);
    //         setltsCarga(null);
    //     };
    // };